import axios, { AxiosError } from 'axios';

import { FileOpener } from '@capacitor-community/file-opener';
import { FirebasePerformance } from '@capacitor-firebase/performance';
import { Directory, Filesystem } from '@capacitor/filesystem';
import jwt_decode from 'jwt-decode';
import { ListOption } from "../entities/commons/list-option.model";
import { getCurrentLang, getCurrentLanguage } from './locate';

import { getConsolidatedRightsValueCache, getContributionsQueryPromoterCache, getCurrentUserProduct, getDeviceId, getDocumentsControlCommisionCache, getDocumentsPromoterCache, getDocumentsTypeCompaniesOnlineCorrespondenceCache, getDocumentsTypeOnlineCorrespondenceCache, getExternalFundsCache, getFaqsCache, getForInvestorCache, getFundFiscalInformationCache, getGlobalPositionCache, getGlobalPositionControlCommisionCache, getGlobalPositionPromoterCache, getInfoContractCache, getInfoProductCache, getInitContentCache, getInvestmentFundsCache, getInvestmentFundsNotContractedCache, getListOptionsCache, getNetAssetValueCache, getNewBySlugCache, getNewsCache, getNewsMostReadCache, getNewsPageCache, getNumberAdvisesCache, getNumberCourseOperationsCache, getOptionsCache, getOtherProductsCache, getOtherQueriesControlCommisionCache, getOtherQueriesPromotersCache, getParticipantsVariationBeneficiariesCache, getPaymentTotalBenefitsCache, getPeriodicitiesCache, getPlanFiscalInformationCache, getPlansCache, getPlansNotContractedCache, getProductsCache, getProfitabilityPercentageCache, getSelectedPlanComisionControl, getSelectedPlanPromotor, getSuggestionsSearchCache, getTextsCache, getTextsVersion, getToken, getTotalsContributionsCache, getTransfersCache, getUser, getVersionApp, getWalletCompositionProductCache, getWordsSearchCache, removeTextsVersion, removeUser, setConsolidatedRightsValueCache, setContributionsQueryPromoterCache, setCurrentProductToContract, setCurrentUserContract, setCurrentUserData, setDocumentsControlCommisionCache, setDocumentsPromoterCache, setDocumentsTypeCompaniesOnlineCorrespondenceCache, setDocumentsTypeOnlineCorrespondenceCache, setExternalFundsCache, setFaqsCache, setForInvestorCache, setFundFiscalInformationCache, setGlobalPositionCache, setGlobalPositionControlCommisionCache, setGlobalPositionPromoterCache, setInfoContractCache, setInfoProductCache, setInitContentCache, setInvestmentFundsCache, setInvestmentFundsNotContractedCache, setListOptionsCache, setModeMaintenance, setNetAssetValueCache, setNewBySlugCache, setNewsCache, setNewsMostReadCache, setNewsPageCache, setNumberAdvisesCache, setNumberCourseOperationsCache, setOptionsCache, setOtherProductsCache, setOtherQueriesControlCommisionCache, setOtherQueriesPromotersCache, setParticipantsVariationBeneficiariesCache, setPaymentTotalBenefitsCache, setPeriodicitiesCache, setPlanFiscalInformationCache, setPlansCache, setPlansNotContractedCache, setProductsCache, setProfitabilityPercentageCache, setSuggestionsSearchCache, setTextsCache, setTextsVersion, setToken, setTotalsContributionsCache, setTransfersCache, setWalletCompositionProductCache, setWordsSearchCache } from './storage';

import messagesEN from "../i18n/en.json";
import messagesES from "../i18n/es.json";


import { CheckIdCardResponse } from '../entities/clients/check-idcard-response';
import { Client } from '../entities/clients/client';
import { ClientsLoginBody } from '../entities/clients/clients-login-body';
import { RegisterResponse } from '../entities/clients/register-response';
import { ExternalFund } from '../entities/commons/external-fund.model';
import { Option } from '../entities/commons/option.model';
import { Periodicity } from '../entities/commons/periodicity.model';
import { ZipData } from '../entities/commons/zip-data';
import { Contact } from '../entities/contact/contact.model';
import { Content } from '../entities/contents/content.model';
import { Contents } from '../entities/contents/contents.model';
import { Faq } from '../entities/contents/faq.model';
import { ForInvestor } from '../entities/contents/for-investor.model';
import { ResultCalculateFinalCapitalTaxSavingsContribution } from '../entities/contents/result-calculate-final-capital-tax-savings-contribution';
import { ResultCalculateFinalCapitalTaxSavingsTransfer } from '../entities/contents/result-calculate-final-capital-tax-savings-transfer';
import { ResultCalculatorCommisionSavingsContribution } from '../entities/contents/result-calculator-commision-savings-contribution.model';
import { ResultCalculatorCommisionSavingsTransfer } from '../entities/contents/result-calculator-commision-savings-transfer.model';
import { ResultCalculatorDecideYourInvestment } from '../entities/contents/result-calculator-decide-your-investment.model';
import { SearchContents } from '../entities/contents/search-content.model';
import { Status } from '../entities/contents/status.model';
import { SuggestionSearch } from '../entities/contents/suggestion-search.model';
import { Contract } from '../entities/contract/contract';
import { ContractSituation } from '../entities/contract/contract-situation.model';
import { ContractHolder } from '../entities/contract/contractHolder';
import { Contribution } from '../entities/contract/contribution';
import { Movement } from '../entities/contract/movement';
import { OperationContract } from '../entities/contract/operations/operation-contract';
import { OperationContractFund } from '../entities/contract/operations/operation-contract-fund';
import { OperationContractHolders } from '../entities/contract/operations/operation-contract-holders';
import { OperationContractPlan } from '../entities/contract/operations/operation-contract-plan';
import { OperationContribution } from '../entities/contract/operations/operation-contribution';
import { OperationMobilization } from '../entities/contract/operations/operation-mobilization';
import { OperationRefund } from '../entities/contract/operations/operation-refund';
import { OperationSubscription } from '../entities/contract/operations/operation-subscription';
import { OperationTransfer } from '../entities/contract/operations/operation-transfer';
import { Rights } from '../entities/contract/rights';
import { SignState } from '../entities/contract/sign-state.model';
import { GlobalPosition } from '../entities/globalPosition/globalPosition';
import { NewDetail } from '../entities/news/news-detail.model';
import { NewsParameters } from '../entities/news/news-parameters.model';
import { News } from '../entities/news/news.model';
import { NewsletterSubscription } from '../entities/news/newsletter-subscription';
import { TagNews } from '../entities/news/tag.model';
import { Notices } from '../entities/notices/notices.model';
import { DocumentSearch } from '../entities/onlineCorrespondence/document-search.model';
import { DocumentTypeCO } from '../entities/onlineCorrespondence/document-type.model';
import { DocumentCO } from '../entities/onlineCorrespondence/document.model';
import { OperationInProgress } from '../entities/operationsInProgress/operation-in-progress.model';
import { Company } from '../entities/products/company.model';
import { NetAssetValue } from '../entities/products/net-asset-value';
import { PortfolioComposition } from '../entities/products/portfolio-composition';
import { Product } from '../entities/products/product';
import { ProductDocument } from '../entities/products/product-document';
import { UserProduct } from '../entities/products/userProduct';
import { ClosingData } from '../entities/promoters-control-commision/closing-data';
import { GlobalPositionControlCommision } from '../entities/promoters-control-commision/global-position-control-commision';
import { GlobalPositionPromoter } from '../entities/promoters-control-commision/global-position-promoter';
import { OtherQueriesPromoter } from '../entities/promoters-control-commision/other-queries';
import { OtherQueriesControlCommision } from '../entities/promoters-control-commision/other-queries-control-commision';
import { Transfers } from '../entities/promoters-control-commision/transfers';
import { LostProfit } from '../entities/taxInformation/lost-profit.model';
import { TaxInformationFunds } from '../entities/taxInformation/tax-information-funds.model';
import { TaxInformationFundYear } from '../entities/taxInformation/tax-information-fy.model';
import { TaxInformationPlanYear } from '../entities/taxInformation/tax-information-py.model';
import { TaxInformation } from '../entities/taxInformation/tax-information.model';
import LoginPage from '../pages/private/login/LoginPage';
import AboutUsPage from '../pages/public/about-us/AboutUsPage';
import CertificatesPage from '../pages/public/certificates/CertificatesPage';
import ContactPage from '../pages/public/contact/ContactPage';
import CookiesPolicyPage from '../pages/public/cookies-policy/CookiesPolicyPage';
import CopyrightPage from '../pages/public/copyright/CopyrightPage';
import DataProtectionPage from '../pages/public/data-protection/DataProtectionPage';
import EmploymentSystemPensionPlansPage from '../pages/public/employment-system-pension-plans/EmploymentSystemPensionPlansPage';
import SolutionForCompaniesPage from '../pages/public/employment-system-pension-plans/SolutionsForCompaniesPage';
import SolutionsForFreelancersPage from '../pages/public/employment-system-pension-plans/SolutionsForFreelancersPage';
import ForInvestorPage from '../pages/public/for-investor/ForInvestorPage';
import CommissionSavingsCalculatorPage from '../pages/public/for-investor/calculators/CommissionSavingsCalculatorPage';
import ComplementarySavingsCalculatorPage from '../pages/public/for-investor/calculators/ComplementarySavingsCalculatorPage';
import CustomizeInvestmentFundPage from '../pages/public/for-investor/calculators/DecideYourInvestmentCalculatorPage';
import FinalCapitalCalculatorPage from '../pages/public/for-investor/calculators/FinalCapitalCalculatorPage';
import HomePage from '../pages/public/home/HomePage';
import InvestmentFundsPage from '../pages/public/investment-funds/InvestmentFundsPage';
import IsrInFonditelPage from '../pages/public/landings/sustainability/IsrInFonditelPage';
import LegalNoticePage from '../pages/public/legal-notice/LegalNoticePage';
import OperationalWebPage from '../pages/public/operational-web/OperationalWebPage';
import PensionPlansPage from '../pages/public/pension-plans/PensionPlansPage';
import { getOptionNavigationInverse, getUrlNavigation } from './navigation';
import { fileToBase64, getPlatform, getPlatformDetail, isNativeApp, trackError, translateProduct } from './utils';
import { DocumentSustainability } from '../entities/sustainability/document-sustainability.model';

const callApiGet = async <T>(endpoint: string, params: any = null, tokenRequired: boolean=true, retries: number = 0) => {
    if(tokenRequired && !isValidToken()){
        removeUser();
        return null as T;
    }
    return callApi<T>('GET', process.env.REACT_APP_API_URL+endpoint, params, tokenRequired);
}

const callApiPost = async <T>(endpoint: string, params: any = null, tokenRequired: boolean=true, retries: number = 0) => {
    if(tokenRequired && !isValidToken()){
        removeUser();
        return null as T;
    }
    return callApi<T>('POST', process.env.REACT_APP_API_URL+endpoint, params, tokenRequired);
}

const callApiDNIE = async <T>(endpoint: string, params: any = null, tokenRequired: boolean=true, retries: number = 0) => {
    if(tokenRequired && !isValidToken()){
        removeUser();
        return null as T;
    }
    return callApi<T>('POST', process.env.REACT_APP_API_URL_DNIE+endpoint, params, tokenRequired);
}

const callApi = async <T>(method:string, url: string, params: any = null, tokenRequired: boolean=true) => {



    try{
        if(isNativeApp){
            FirebasePerformance.startTrace({ traceName: url }).then(()=>{});
        }
    }catch(err){}

    const urlMaintenance = getCurrentLang()==='es' ? '/mantenimiento' : '/en/maintenance';
    const timeoutMs = 120000;
    const timeout = setTimeout(() => {
        //window.location.href=urlMaintenance;
      }, timeoutMs);

    let result =null;



    result = await axios<T>({
        transitional: {silentJSONParsing: false},
        method: method,
        url: url,
        data: params ? params : null,
        //timeout: timeoutMs,
        headers: tokenRequired  ? { Authorization: `Bearer ${ getTokenApi()}`, Accept: `application/json`, "Content-Type": `application/json` } : {Accept: `application/json`, "Content-Type": `application/json` }
    }).then((res) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: url }).then(()=>{});
            }
        }catch(err){}
        clearTimeout(timeout);
        const data = res.data as any;
        if(data && data.token){
            setToken(data.token);
        }
        if(data && data.data){
            return (typeof data.data ==='string' ? JSON.parse(data.data) : data.data ) as T;
        }
        if(data && data.resultData){
            return (typeof data.resultData ==='string' ? JSON.parse(data.resultData) : data.resultData ) as T;
        }
        return (typeof res.data ==='string' ? JSON.parse(res.data) : res.data ) as T;
    })
    .catch(async (error: AxiosError) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: url }).then(()=>{});
            }
        }catch(err){}

        let apidnie = process.env.REACT_APP_API_URL_DNIE ? url.indexOf(process.env.REACT_APP_API_URL_DNIE)!==-1 : false;

        clearTimeout(timeout);

        if (!apidnie && error.code==='ERR_NETWORK'){
            clearTimeout(timeout);

            if(!isNativeApp && window.location.pathname!==urlMaintenance){
                window.location.href=urlMaintenance;
                return;
            }
        }
        let data = error?.response?.data as any;
        if(data && data.class==='App\\Exception\\User\\UserInvalidException'){
            throw error;
        }

        if(apidnie){
            throw error;
        }

        trackError('Error call api: '+(url)+ ' - '+(error?.message ?? ''));
    });
    return await result as T;
}

export const isValidToken = () =>{
    return getTokenApi()!==null;
}

const getTokenApi = () =>{
    const token = getToken();

    if(token){
        const decode: any = jwt_decode(token);
        if((Date.now() / 1000) < decode.exp){
            return token;
        }else{
            //Token caducado - cierre de sesión
        }
    }
    return null;
}

export function getProvisionalTexts() {
    const messages : any={en:{}, es:{}}
    if(messages.es){
        const keyES =Object.keys(messages.es);
        for(const [key, info] of Object.entries(messagesES)){
            if(!keyES.find(item=>item===key)){
                messages.es[key]=info;
            }
        }
    }
    if(messages.en){
        const keyEN =Object.keys(messages.en);
        for(const [key, info] of Object.entries(messagesEN)){
            if(!keyEN.find(item=>item===key)){
                messages.en[key]=info;
            }
        }
    }
    return messages;
}

/* Get status
========================================================= */
export async function getStatus(): Promise<Status|null> {
    const preview = window.location.search.toLowerCase().indexOf('preview=true')!==-1;
    if(preview || getTextsCache()===null){
        removeTextsVersion();
    }
    const params = {
        lang: getCurrentLang(),
        platform: getPlatformDetail(),
        deviceId: getDeviceId(),
        version: getVersionApp(),
        textsVersion: getTextsVersion()
    }

    try{
        let data = await callApiPost<Status>('/master_datas/get_status', params, false);

        if(data){
            if(data.updateTexts){
                if(!data.messages){
                    data.messages={en:{}, es:{}}
                }
                if(data.messages.es){
                    const keyES =Object.keys(data.messages.es);
                    for(const [key, info] of Object.entries(messagesES)){
                        if(!keyES.find(item=>item===key)){
                            data.messages.es[key]=info;
                        }
                    }
                }
                if(data.messages.en){
                    const keyEN =Object.keys(data.messages.en);
                    for(const [key, info] of Object.entries(messagesEN)){
                        if(!keyEN.find(item=>item===key)){
                            data.messages.en[key]=info;
                        }
                    }
                }
                setTextsCache(data.messages);
            }

            if(data.maintenance){
                trackError('App is running in maintenance mode');
            }

            setModeMaintenance(data.maintenance);
            return data;
        }
    }catch(err){
        setModeMaintenance(true);
    }

    trackError('App is running in maintenance mode');
    let messages = getTextsCache();

    if(!messages){
        messages = getProvisionalTexts();
    }
    setModeMaintenance(true);
    removeTextsVersion();

    return new Status(true, false, true, undefined, getProvisionalTexts());
}

export async function getDictionary(): Promise<string[]>{

    const lang= getCurrentLang();
    const params = {
        lang: lang,
        dictionary: true
    }

   let key = 'lang_'+lang;
   let cache = getWordsSearchCache(key);
   if(cache){
       return cache;
   }

   const result = await callApiPost<string[]>('/contents/search', params, false);
   if(result && result.length){
    setWordsSearchCache(result, key);
   }

   return result;
}


export async function search(search:string): Promise<SearchContents> {
    const lang= getCurrentLang();
    const params = {
        lang: lang,
        text: search,
        dictionary: false
    }

    const response = await callApiPost<SearchContents>('/contents/search', params, false);

    let matchs : any[] = [];
    if(response.matchs && Object.entries(response.matchs).length>0){

        const arr = Object.values(response.matchs) as any[];
        arr.forEach(match  =>{
            if(match.type==='pages'){
                if(match.item.nbClave.indexOf('error')===-1 && match.item.nbClave.indexOf('invalid')===-1 && match.item.nbClave.indexOf('seo')===-1 && match.item.nbClave.indexOf('link')===-1){
                    match.content = lang==='es' ? match.item.nbTraduccionEs : match.item.nbTraduccionEn;
                    if(match.item.nbClave.startsWith('page_home')){
                        match.title='page_home_title';
                        match.url = getUrlNavigation(HomePage);
                    }else if(match.item.nbClave.startsWith('page_about_us')){
                        match.title='page_about_us_title';
                        match.url = getUrlNavigation(AboutUsPage);
                    }else if(match.item.nbClave.startsWith('page_certificates')){
                        match.title='page_certificates_title';
                        match.url = getUrlNavigation(CertificatesPage);
                    }else if(match.item.nbClave.startsWith('page_contact')){
                        match.title='page_contact_title';
                        match.url = getUrlNavigation(ContactPage);
                    }else if(match.item.nbClave.startsWith('page_cookies_policy')){
                        match.title='page_cookies_policy_title';
                        match.url = getUrlNavigation(CookiesPolicyPage);
                    }else if(match.item.nbClave.startsWith('page_copyright')){
                        match.title='page_copyright_title';
                        match.url = getUrlNavigation(CopyrightPage);
                    }else if(match.item.nbClave.startsWith('page_data_protection')){
                        match.title='page_data_protection_title';
                        match.url = getUrlNavigation(DataProtectionPage);
                    }else if(match.item.nbClave.startsWith('page_employment_system_pension') || match.item.nbClave.startsWith('page_simplified_pension_plans')){
                        match.title='page_employment_system_pension_plans_page_title';
                        match.url = getUrlNavigation(EmploymentSystemPensionPlansPage);
                    }else if(match.item.nbClave.startsWith('page_solutions_for_companies')){
                        match.title='page_solutions_for_companies_page_title';
                        match.url = getUrlNavigation(SolutionForCompaniesPage);
                    }else if(match.item.nbClave.startsWith('page_solutions_for_freelancers')){
                        match.title='page_solutions_for_freelancers_page_title';
                        match.url = getUrlNavigation(SolutionsForFreelancersPage);
                    }else if(match.item.nbClave.startsWith('page_for_investor')){
                        match.title='page_for_investor_page_title';
                        match.url = getUrlNavigation(ForInvestorPage);
                    }else if(match.item.nbClave.startsWith('page_commission_savings_calculator')){
                        match.title='page_commission_savings_calculator_title';
                        match.url = getUrlNavigation(CommissionSavingsCalculatorPage);
                    }else if(match.item.nbClave.startsWith('page_complementary_savings_calculator')){
                        match.title='page_complementary_savings_calculator_title';
                        match.url = getUrlNavigation(ComplementarySavingsCalculatorPage);
                    }else if(match.item.nbClave.startsWith('page_decide_your_investment_calculator')){
                        match.title='page_decide_your_investment_calculator_title';
                        match.url = getUrlNavigation(CustomizeInvestmentFundPage);
                    }else if(match.item.nbClave.startsWith('page_final_capital_calculator')){
                        match.title='page_final_capital_calculator_title';
                        match.url = getUrlNavigation(FinalCapitalCalculatorPage);
                    }else if(match.item.nbClave.startsWith('page_investment_funds')){
                        match.title='page_investment_funds_title';
                        match.url = getUrlNavigation(InvestmentFundsPage);
                    }else if(match.item.nbClave.startsWith('page_pension_plans')){
                        match.title='page_pension_plans_title';
                        match.url = getUrlNavigation(PensionPlansPage);
                    }else if(match.item.nbClave.startsWith('page_legal_notice')){
                        match.title='page_legal_notice_title';
                        match.url = getUrlNavigation(LegalNoticePage);
                    }else if(match.item.nbClave.startsWith('page_operational_web')){
                        match.title='page_operational_web_title';
                        match.url = getUrlNavigation(OperationalWebPage);
                    }else if(match.item.nbClave.startsWith('page_login')){
                        match.title='page_login_title';
                        match.url = getUrlNavigation(LoginPage);
                    }else if(match.item.nbClave.startsWith('page_sustainability')){
                        match.title='page_sustainability_meta_title';
                        match.url = getUrlNavigation(IsrInFonditelPage);
                    }
                }

                if(match.url){
                    matchs.push(match);
                }
            }else{
                matchs.push(match);
            }
        })
        response.matchs = matchs;
    }
    return response;
}


/* Init Content
========================================================= */
export async function getInitContent(loadMessages:boolean=false): Promise<Contents> {
    const preview = loadMessages || window.location.search.toLowerCase().indexOf('preview=true')!==-1;
    const lang=getCurrentLang();

    const isMaintenance = window.location.href.indexOf('/mantenimiento')!==-1 || window.location.href.indexOf('/en/maintenance')!==-1
    let data: Contents={}
    let dataContent = preview ? null : getInitContentCache(lang);

    if(!isMaintenance && !dataContent){
        data = await callApiPost<Contents>('/contents/get_content', {lang:lang, preview: preview ? preview : undefined}, false);

        if(data.masters){
            for(const [lang, dataMasters] of Object.entries(data.masters)){
                for(const [key, info] of Object.entries(dataMasters as any)){
                    setListOptionsCache(key+'_options', info as ListOption[],lang);
                }
            }
        }

        if(data.suggestionSearch){
            for(const [lang, dataSuggestions] of Object.entries(data.suggestionSearch as any)){
                const contentSuggestions = dataSuggestions as SuggestionSearch[];

                let key = 'lang_'+lang;
                setSuggestionsSearchCache(contentSuggestions, key);
            }
        }

        if(data.faqs){
            for(const [lang, dataFaqs] of Object.entries(data.faqs as any)){
                const contentFaqs = dataFaqs as Faq[];
                const product = true;
                const forInvestor = false;
                let cdCompany = parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES??'1');
                let faqs = contentFaqs.filter(item=>item.cdCompania===cdCompany);
                let key = 'lang_'+lang+'_'+(cdCompany??'')+'_'+(forInvestor??'')+'_'+(product??'');
                if(faqs && faqs.length>0){
                    setFaqsCache(faqs, key);
                }

                cdCompany = parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS??'3');
                faqs = contentFaqs.filter(item=>item.cdCompania===cdCompany);
                key = 'lang_'+lang+'_'+(cdCompany??'')+'_'+(forInvestor??'')+'_'+(product??'');
                if(faqs && faqs.length>0){
                    setFaqsCache(faqs, key);
                }
            }
        }

        if(data?.lastUpdateTranslates){
            setTextsVersion(data?.lastUpdateTranslates);
        }
    }else if(dataContent){
        data=dataContent;
    }

    if(loadMessages){
        if(!data.messages){
            data.messages={en:{}, es:{}}
        }
        if(data.messages.es){
            const keyES =Object.keys(data.messages.es);
            for(const [key, info] of Object.entries(messagesES)){
                if(!keyES.find(item=>item===key)){
                    data.messages.es[key]=info;
                }
            }
        }
        if(data.messages.en){
            const keyEN =Object.keys(data.messages.en);
            for(const [key, info] of Object.entries(messagesEN)){
                if(!keyEN.find(item=>item===key)){
                    data.messages.en[key]=info;
                }
            }
        }

        setTextsCache(data.messages);
    }

    setInitContentCache(data, lang);

    return data;
}

/* SuggestionsSearch
========================================================= */
export async function getSuggestionsSearch(): Promise<SuggestionSearch[]> {
    const lang=getCurrentLang();

    let key = 'lang_'+lang;
    await getInitContent();
    let cache = getSuggestionsSearchCache(key);
    if(cache){
        return cache;
    }
    return [];
}

/* Faqs
========================================================= */
export async function getFaqs(cdCompany?:number, forInvestor?:boolean, product?:boolean): Promise<Faq[]> {
    const preview = window.location.search.toLowerCase().indexOf('preview=true')!==-1;
    await getInitContent();
    const lang=getCurrentLang();

    let key = 'lang_'+lang+'_'+(cdCompany??'')+'_'+(forInvestor??'')+'_'+(product??'');
    let cache = preview ? null : getFaqsCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Faq[]>('/contents/get_frequent_questions', {cdCompany:cdCompany, forInvestor: forInvestor, product:product, lang:lang, preview: preview ? preview : undefined}, false);
    if(response){
        setFaqsCache(response, key);
    }
    return response;
}

/* For investor
========================================================= */
export async function getForInvestor(): Promise<ForInvestor> {
    const preview = window.location.search.toLowerCase().indexOf('preview=true')!==-1;
    const lang=getCurrentLang();

    let key = 'lang_'+lang;
    let cache = preview ? null : getForInvestorCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<ForInvestor>('/contents/get_for_investor', {lang:lang, preview: preview ? preview : undefined}, false);

    if(response){
        setForInvestorCache(response, key);
    }
    return response;
}

/* Calculator of contributions of commissions savings
========================================================= */
export async function calculateCommissionsSavingsContribution(params:any): Promise<ResultCalculatorCommisionSavingsContribution> {
    const lang=getCurrentLang();
    params.lang = lang;

    const response = await callApiPost<ResultCalculatorCommisionSavingsContribution>('/contents/calculator_commissions_savings_contribution', params, false);
    return response;
}

/* Calculator of transfer of commissions savings
========================================================= */
export async function calculateCommissionsSavingsTransfer(params:any): Promise<ResultCalculatorCommisionSavingsTransfer> {
    const lang=getCurrentLang();
    params.lang = lang;

    const response = await callApiPost<ResultCalculatorCommisionSavingsTransfer>('/contents/calculator_commissions_savings_transfer', params, false);
    return response;
}

/* Calculator of contribution of final capital and tax savings
========================================================= */
export async function calculateFinalCapitalTaxSavingsContribution(params:any): Promise<any> {
    const lang=getCurrentLang();
    params.lang = lang;

    const response = await callApiPost<ResultCalculateFinalCapitalTaxSavingsContribution>('/contents/calculator_final_capital_and_tax_savings_contribution', params, false);
    return response;
}

/* Calculator of contribution of final capital and tax savings
========================================================= */
export async function calculateFinalCapitalTaxSavingsTransfer(params:any): Promise<any> {
    const lang=getCurrentLang();
    params.lang = lang;

    const response = await callApiPost<ResultCalculateFinalCapitalTaxSavingsTransfer>('/contents/calculator_final_capital_and_tax_savings_transfer', params, false);
    return response;
}

/* Calculator of decide your investment
========================================================= */
export async function calculateDecideYourInvestment(params:any): Promise<ResultCalculatorDecideYourInvestment[]> {
    const lang=getCurrentLang();
    params.lang = lang;

    const response = await callApiPost<ResultCalculatorDecideYourInvestment[]>('/contents/calculator_decide_your_investment', params, false);
    return response;
}

export async function getContent(type:string, modal:boolean = false): Promise<Content|undefined> {
    const language = getCurrentLanguage();

    await getInitContent();
    let contents = getInitContentCache(language.value);
    
    if(modal){
        return contents?.modal;
    }else if(contents && contents.content){
        return contents.content.find(item=>item.cdIdioma===language.cdLang && item.clave.toLowerCase()===type);
    }else{
        //API
    }

    return undefined;
}

/*****************CLIENTS******************/
export async function login(params:ClientsLoginBody): Promise<Client> {
    removeUser();
    params.lang=getCurrentLang();
    const client: Client = params.electronic ? await callApiDNIE<Client>('/clients/login', params, false) : await callApiPost<Client>('/clients/login', params, false);

    if(client){
        if(client.roles){
            client.roles = Object.values(client.roles);
        }

        if(client.avisos!==undefined){
            setNumberAdvisesCache({result: client.avisos});
        }
        if(client.operacionesPendientes!==undefined){
            setNumberCourseOperationsCache({result: client.operacionesPendientes});
        }
        if(client.tiposDocumentoCO!==undefined){
            setDocumentsTypeCompaniesOnlineCorrespondenceCache(params.lang, client.tiposDocumentoCO);

            client.tiposDocumentoCO.forEach(item  =>{
                setDocumentsTypeOnlineCorrespondenceCache(getCurrentLang(), item.cdCompania, item.tiposDocumentos);
            });
        }
    }

    return client;
}

export async function getUserByNif(nif:string): Promise<Client> {
    const params = { nif: nif, lang:getCurrentLang()}
    const client: Client = await callApiPost<Client>('/clients/validate_contract_holder', params);
    return client;
}

export async function sendMailTechnicalClaims(params:{ name: string, lastname: string, email: string, phone: string, claim: string, lang: string }): Promise<any> {
    params.lang=getCurrentLang();
    const result =  await callApiPost<any>('/contents/send_mail_technical_claims', params, false);
    return result;
}

export async function recoveryPassword(params:any): Promise<{result:{sent_email:boolean, sent_sms:boolean, phone_numbers?:string}}> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{result:{sent_email:boolean, sent_sms:boolean, phone_numbers?:string}}>('/clients/generate_recovery_password', params, false);
    return result;
}

export async function updatePasswordUser(params: any): Promise<any> {
    const result = await callApiPost<any>('/clients/update_pass_user', params, true);
    return result;
}

export async function setPasswordUser(params: { oldPassword: string, newPassword: string, lang: string }): Promise<any> {

    const result = await callApiPost<any>('/clients/set_pass_user', params, true);
    return result;
}

export async function updateOperationsKeyUser(params: any): Promise<any> {
    const result = await callApiPost<any>('/clients/update_operations_key_user', params, true);
    return result;
}

export async function updateDataUser(params: any): Promise<any> {
    const result = await callApiPost<any>('/clients/update_data_user', params, true);
    return result;
}

export async function setOperationsKey(params: { oldKey: string, newKey: string, lang: string }): Promise<any> {
    const result = await callApiPost<any>('/clients/set_operations_key', params, true);
    return result;
}

export async function setStateSignaturit(params: { document_id: string, signature_id: string, state: string }): Promise<any> {
    const result = await callApiPost<any>('/clients/set_state_signaturit', params, true);
    return result;
}

export async function setStateSignaturitWithoutToken(params: { identifier: string, document_id: string, signature_id: string, state: string }): Promise<any> {
    const result = await callApiPost<any>('/clients/set_state_signaturit_without_token', params, false);
    return result;
}

export async function getContractsSituation(params: any): Promise<ContractSituation> {
    params.lang=getCurrentLang()
    const result = await callApiPost<ContractSituation>('/clients/get_contracts_situation', params, true);
    return result;
}

export async function formalizeContractSignaturit(): Promise<{ result: string, urlSignature: string }> {
    const result = await callApiPost<{ result: string, urlSignature: string }>('/clients/formalize_contract_signaturit', {}, true);
    return result;
}

export async function formalizeContractSignaturitBA(params:any): Promise<{ result: string, urlSignature: string }> {
    params.lang=getCurrentLang();
    params.logSource = getPlatform();

    const result = await callApiPost<{ result: string, urlSignature: string }>('/products/plan/generate_url_boletin', params, false);
    
    return result;
}

export async function verifyCodeRecoveryPassword(params:any): Promise<{result:{sent_email:boolean, sent_sms:boolean, phone_numbers?:string}}> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{result:{sent_email:boolean, sent_sms:boolean, phone_numbers?:string}}>('/clients/verify_code_recovery_password', params, false);
    return result;
}

export async function getDataRecoveryPassword(params:any): Promise<{ result: string, identifier: string }> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{ result: string, identifier: string }>('/clients/get_data_recovery_password', params, false);
    return result;
}

export async function setDataRecoveryPassword(params:any): Promise<{ result: string, errors?: [] }> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{ result: string, errors?: [] }>('/clients/set_data_recovery_password', params, false);
    return result;
}

export async function generateRecoveryOperationsKey(params:any): Promise<{ result: string, errors?: [] }> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{ result: string, errors?: [] }>('/clients/generate_recovery_operations_key', params, true);
    return result;
}

export async function setDataOperationsKeyRecovery(params:any): Promise<{ result: string }> {
    params.lang=getCurrentLang()
    const result =  await callApiPost<{ result: string }>('/clients/set_data_recovery_operations_key', params, false);
    return result;
}

export async function numberAttempsOperationsKey(): Promise<{ result: number }> {
    const result =  await callApiPost<{ result: number }>('/clients/number_attemps_operations_key', {}, true);
    return result;
}

export async function checkIdCard(params:any): Promise<CheckIdCardResponse> {
    params.lang=getCurrentLang();

    const client: CheckIdCardResponse = params.electronic ? await callApiDNIE<CheckIdCardResponse>('/clients/check_idcard', params, false) : await callApiPost<CheckIdCardResponse>('/clients/check_idcard', params, false);

    return client;
}

export async function checkDataRegister(params:any): Promise<CheckIdCardResponse> {
    params.lang=getCurrentLang();

    const client: CheckIdCardResponse = await callApiPost<CheckIdCardResponse>('/clients/check_register', params, false);

    return client;
}

export async function activateAccount(params:any): Promise<{ result: string, identifier: string, product?: string  }> {
    const result = await callApiPost<{ result: string, identifier: string, product?: string}>('/clients/activate_account', params, false);

    return result;
}

export async function setSignContract(params:any): Promise<{ result: string, urlSignature: string }> {
    const result = await callApiPost<{ result: string, urlSignature: string }>('/clients/set_sign_contract', params, false);

    return result;
}

export async function downloadContractDocument(title:string, identifier?:string) {
    if(identifier){
        await callApiDownload(title + '.pdf', title, '/documents/download_contract_document', {identifier: identifier}, false);
    }else{
        await callApiDownload(title + '.pdf', title, '/documents/contract_customer_document', {}, true);
    }
}
export async function downloadAttachmentSignedDocument(title:string, signatureId:string|null, documentId:string|null) {
    await callApiDownload(title + '.zip', title, '/documents/download_attachment_signed_document', {signatureId: signatureId, documentId: documentId}, false);
}
export async function downloadSignedDocument(title:string, signatureId:string|null, documentId:string|null) {
    await callApiDownload(title + '.pdf', title, '/documents/download_signed_document', {signatureId: signatureId, documentId: documentId}, false);
}

export async function register(params:any){
    params.lang=getCurrentLang();
    const register: RegisterResponse = await callApiPost<RegisterResponse>('/clients/register', params, false);

    return register;
}

export async function isValidCurrentOperationsKey(): Promise<boolean> {
    return await callApiPost<boolean>('/clients/is_valid_current_operations_key', {}, true);
}

export async function isValidOperationsKey(params:any): Promise<{ result: string, errors?: [], retries?: number}> {
    const result =  await callApiPost<{ result: string, errors?: [], retries?: number }>('/clients/is_valid_operations_key', params, true);
    return result;
}

export async function formalizeSignUserData(params: { email: string, phone: string, mobile: string, lang: string }): Promise<{ result: string }> {
    const result =  await callApiPost<{ result: string }>('/clients/formalize_sign_user_data', params, true);
    return result;
}

export async function formalizeOperationKey(params:any): Promise<{ result: string, errors?: []}> {
    const result =  await callApiPost<{ result: string, errors?: []}>('/clients/formalize_user_operations_key', params, true);
    return result;
}

export async function setDataClient(params: {gender: string, phone: string, mobile: string, email: string, occupation: string, activity: string, telefonicaGroupEmployee: boolean, publicCharges: string, nifEEUU: boolean, activitySpecify: string, personPublicResponsibility: boolean, personPublicResponsibilityPosition: string, personPublicResponsibilityOrganism: string, familyPublicResponsibilityOrganism: boolean, relatedPublicResponsibilityOrganism: boolean, ongPositionLast2Years: boolean, lang: string, logSource: string, operationsKey?: string, confirm?: boolean, electronic?: boolean, dateSign?: number, tokenSign?: string, tokenOperation?: string}): Promise<{result: string, errors?: [], tokenOperation?:string}> {
    const result =  await callApiPost<{result: string, errors?: [], tokenOperation?:string}>('/clients/set_data_client', params, true);
    return result;
}

/*****************UTILS******************/
export async function getPeriodicities(): Promise <Periodicity[]>{
    const type='periodicities';
    const key_option = type+'_options';
    const language = getCurrentLang();
    let options = getPeriodicitiesCache(key_option, language);
    if(options && options.length>0){
        return options;
    }

    options = await callApiPost<Periodicity[]>('/master_datas/get_data', {'type':type, 'lang':language}, false);
    if(!options){
        options=[];
    }
    setPeriodicitiesCache(key_option, options, language);

    return options
}

export async function getPlanManagers(cdCompany:number): Promise<Option[]> {
    const type='planManagers';
    const key_option = type+'_cdCompany_'+cdCompany+'_options';
    const language = getCurrentLang();
    let options = getOptionsCache(key_option, language);
    if(options && options.length>0){
        return options;
    }

    options = await callApiPost<Option[]>('/master_datas/get_data', {'type':type, 'cdCompany':cdCompany, 'lang':language}, false);
    if(!options){
        options=[];
    }
    setOptionsCache(key_option, options, language);

    return options
}

export async function getExternalPlans(planManager:string): Promise<Option[]> {
    const type='externalPlans';
    const key_option = type+'_planManager_'+planManager+'_options';
    const language = getCurrentLang();
    let options = getOptionsCache(key_option, language);
    if(options && options.length>0){
        return options;
    }

    options = await callApiPost<Option[]>('/master_datas/get_data', {'type':type, 'planManager':planManager, 'lang':language}, false);
    if(!options){
        options=[];
    }
    setOptionsCache(key_option, options, language);

    return options
}

export async function getExternalFunds(planManager:string): Promise<ExternalFund[]> {
    const type='externalFunds';
    const key_option = type+'_planManager_'+planManager+'_options';
    const language = getCurrentLang();
    let options = getExternalFundsCache(key_option, language);
    if(options && options.length>0){
        return options;
    }

    options = await callApiPost<ExternalFund[]>('/master_datas/get_data', {'type':type, 'planManager':planManager, 'lang':language}, false);
    if(!options){
        options=[];
    }
    setExternalFundsCache(key_option, options, language);

    return options
}


export async function getMasterDatas(type: string) : Promise<ListOption[]> {
    const key_option = type+'_options';
    const language = getCurrentLang();
    let options = getListOptionsCache(key_option, language);
    if(options && options.length>0){
        return options;
    }

    options = await callApiPost<ListOption[]>('/master_datas/get_data', {'type':type, 'lang':language}, false);
    if(!options){
        options=[];
    }
    setListOptionsCache(key_option, options, language);

    return options
}

export async function getProvinceCity(zip_code: string) : Promise<ZipData> {
    return await callApiGet<ZipData>('/master_datas/location/zip/'+zip_code, {}, false);
}

export async function getNewsPage(params: {numberNews: number, numberNewsMostRead: number, lang?:string}) : Promise<{news: News[], tags:TagNews[], newsMostRead: News[]}> {
    params.lang=getCurrentLang();
    const numberNewsMostRead = params.numberNewsMostRead;
    params.numberNewsMostRead = 3; //Obtenemos 3 para guardarlas en caché durante 1 hora


    let key='news_page_lang_'+params.lang+'_numberNews_'+params.numberNews+'_numberNewsMostRead_'+params.numberNewsMostRead;
    let cache = getNewsPageCache(key);

    if(cache){
        return cache;
    }

    let newsPage = await callApiPost<{news: News[], tags:TagNews[], newsMostRead: News[]}>('/contents/news/get_news_page', params, false);

    if(newsPage && newsPage.newsMostRead && newsPage.newsMostRead.length>0){

        setNewsMostReadCache(newsPage.newsMostRead, params.lang);
        newsPage.newsMostRead = newsPage.newsMostRead.slice(0, numberNewsMostRead);
    }

    if(newsPage){
        setNewsPageCache(newsPage, key);
    }




    return newsPage;
}

export async function getNews(params: NewsParameters) : Promise<News[]> {
    params.lang=getCurrentLang();

    let key='news_lang_'+params.lang+'_numberNews_'+params.numberNews+'_starting_'+params.starting+'_month_'+params.month+'_year_'+params.year+'_search_'+params.search+'_slug_'+params.slug;
    let cache = !params.preview ? getNewsCache(key) : null;

    if(cache){
        return cache;
    }

    let news : News[] = await callApiPost<News[]>('/contents/news', params, false);

    if(news){
        setNewsCache(news, key);
    }

    return news;
}

export async function getTags() : Promise<TagNews[]> {
    let params = new NewsParameters();
    params.lang=getCurrentLang();
    let tags = await callApiPost<TagNews[]>('/contents/news/tags', params, false);
    return tags;
}

export async function getNewBySlug(params: NewsParameters) : Promise<NewDetail> {
    params.lang=getCurrentLang();

    let key='news_by_slug_lang_'+params.lang+'_numberNews_'+params.numberNews+'_slug_'+params.slug;
    if(!params.preview){
        let cache = getNewBySlugCache(key);

        if(cache){
            return cache;
        }
    }

    let newDetail = await callApiPost<NewDetail>('/contents/news/news_slug', params, false);

    if(!params.preview && newDetail){
        setNewBySlugCache(newDetail, key);
    }

    return newDetail;
}

export async function getNewsMostRead(params: NewsParameters) : Promise<News[]> {

    params.lang=getCurrentLang();
    let cache = getNewsMostReadCache(params.lang);

    if(cache && cache.length>0){
        return cache;
    }

    params.numberNews = 3;
    let news = await callApiPost<News[]>('/contents/news/most_read', params, false);

    setNewsMostReadCache(news, params.lang);
    return news;
}

export async function addContact(params: Contact) : Promise<{ result: boolean }> {
    interface AddContactResponse {
      result: boolean;
    }

    let response = await callApiPost<AddContactResponse>('/contents/add_contact', params, false);
    return response;
}

export async function addNewsletterSubscription(params: NewsletterSubscription) : Promise<{ result: string }> {
    interface AddNewsletterSubscriptionResponse {
      result: string;
    }

    let response = await callApiPost<AddNewsletterSubscriptionResponse>('/contents/add_newsletter_subscription', params, false);
    return response;
}


/* Global position control commision
========================================================= */
export async function getGlobalPositionControlCommision(): Promise<GlobalPositionControlCommision>{
    const params : {cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'control_commision_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_lang_'+params.lang;
    let cache = getGlobalPositionControlCommisionCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<GlobalPositionControlCommision>('/control-commission/global_position_cc', params, true);
    if(response){
        setGlobalPositionControlCommisionCache(response, key);
    }
    return response;
}

/* Documents control commision
========================================================= */
export async function getDocumentsControlCommision(from:string): Promise<ProductDocument[]>{
    const params : {cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string, from?:string} = {};
    params.from = from;
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'control_commision_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_from_'+params.from+'_lang_'+params.lang;
    let cache = getDocumentsControlCommisionCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<ProductDocument[]>('/control-commission/control_commission_files_cc', params, true);
    if(response){
        setDocumentsControlCommisionCache(response, key);
    }
    return response;
}


/* Other queries control commision
========================================================= */
export async function getOtherQueriesControlCommision(): Promise<OtherQueriesControlCommision>{
    const params : {idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'control_commision_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_lang_'+params.lang;
    let cache = getOtherQueriesControlCommisionCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<OtherQueriesControlCommision>('/control-commission/other_queries_cc', params, true);
    if(response){
        setOtherQueriesControlCommisionCache(response, key);
    }
    return response;
}



/* Other queries control commision: Participants Variation Beneficiaries
========================================================= */
export async function getParticipantsVariationBeneficiariesControlCommision(month: number, year:number): Promise<ClosingData>{
    const params : {month: number, year:number, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'cc_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getParticipantsVariationBeneficiariesCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<ClosingData>('/control-commission/participants_variation_beneficiaries_cc', params, true);
    if(response){
        setParticipantsVariationBeneficiariesCache(response, key);
    }
    return response;
}

/* Other queries control commision: Consolidated Rights Value
========================================================= */
export async function getConsolidatedRightsValueControlCommision(month: number, year:number): Promise<Rights>{
    const params : {month: number, year:number, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'cc_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getConsolidatedRightsValueCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Rights>('/control-commission/consolidated_rights_value_cc', params, true);
    if(response){
        setConsolidatedRightsValueCache(response, key);
    }
    return response;
}

/* Other queries control commision: Totals Contributions Promoters
========================================================= */
export async function getTotalsContributionsControlCommision(month: number, year:number): Promise<Contribution>{
    const params : {month: number, year:number, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'cc_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getTotalsContributionsCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Contribution>('/control-commission/totals_contributions_promoters_cc', params, true);
    if(response){
        setTotalsContributionsCache(response, key);
    }
    return response;
}


/* Other queries control commision: Payment Total Benefits
========================================================= */
export async function getPaymentTotalBenefitsControlCommision(month: number, year:number): Promise<Contribution>{
    const params : {month: number, year:number, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'cc_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getPaymentTotalBenefitsCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Contribution>('/control-commission/payment_totals_benefits_cc', params, true);
    if(response){
        setPaymentTotalBenefitsCache(response, key);
    }
    return response;
}

/* Other queries control commision: Transfers
========================================================= */
export async function getTransfers(month: number, year:number): Promise<Transfers>{
    const params : {month: number, year:number, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();

    const planCC = getSelectedPlanComisionControl();
    if(planCC){
        params.cdCompany = planCC.cdCompania;
        params.cdPlan = planCC.cdPlan;
        params.cdFund = planCC.cdFondo;
        params.cdSubplan = planCC.cdSubplan;
    }

    let key = 'cc_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getTransfersCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Transfers>('/control-commission/transfers', params, true);
    if(response){
        setTransfersCache(response, key);
    }
    return response;
}

/* Global position promoter
========================================================= */
export async function getGlobalPositionPromoter(): Promise<GlobalPositionPromoter>{
    const params : {idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }


    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_lang_'+params.lang;
    let cache = getGlobalPositionPromoterCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<GlobalPositionPromoter>('/promoter/global_position_promoters', params, true);
    if(response){
        setGlobalPositionPromoterCache(response, key);
    }
    return response;
}

/* Documents promoter
========================================================= */
export async function getDocumentsPromoter(from:string): Promise<ProductDocument[]>{
    const params : {idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string, from?:string} = {};
    params.from = from;
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_lang_'+params.lang+'_from_'+params.from;
    let cache = getDocumentsPromoterCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<ProductDocument[]>('/promoter/promoters_area_documentation', params, true);
    if(response){
        setDocumentsPromoterCache(response, key);
    }
    return response;
}


/* Other queries promoter
========================================================= */
export async function getOtherQueriesPromoters(): Promise<OtherQueriesPromoter>{
    const params : {idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_lang_'+params.lang;
    let cache = getOtherQueriesPromotersCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<OtherQueriesPromoter>('/promoter/other_queries_promoters', params, true);
    if(response){
        setOtherQueriesPromotersCache(response, key);
    }
    return response;
}

/* Other queries promoter: Participants Variation Beneficiaries
========================================================= */
export async function getParticipantsVariationBeneficiariesPromoter(month: number, year:number): Promise<ClosingData>{
    const params : {month: number, year:number, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getParticipantsVariationBeneficiariesCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<ClosingData>('/promoter/participants_variation_beneficiaries', params, true);
    if(response){
        setParticipantsVariationBeneficiariesCache(response, key);
    }
    return response;
}

/* Other queries promoter: Consolidated Rights Value
========================================================= */
export async function getConsolidatedRightsValuePromoter(month: number, year:number): Promise<Rights>{
    const params : {month: number, year:number, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getConsolidatedRightsValueCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Rights>('/promoter/consolidated_rights_value', params, true);
    if(response){
        setConsolidatedRightsValueCache(response, key);
    }
    return response;
}

/* Other queries promoter: Totals Contributions Promoters
========================================================= */
export async function getTotalsContributionsPromoters(month: number, year:number): Promise<Contribution>{
    const params : {month: number, year:number, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getTotalsContributionsCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Contribution>('/promoter/totals_contributions_promoters', params, true);
    if(response){
        setTotalsContributionsCache(response, key);
    }
    return response;
}


/* Other queries promoter: Payment Total Benefits
========================================================= */
export async function getPaymentTotalBenefitsPromoter(month: number, year:number): Promise<Contribution>{
    const params : {month: number, year:number, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {month:month, year:year};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_month_'+params.month+'_year_'+params.year+'_lang_'+params.lang;
    let cache = getPaymentTotalBenefitsCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Contribution>('/promoter/payment_total_benefits', params, true);
    if(response){
        setPaymentTotalBenefitsCache(response, key);
    }
    return response;
}

/* Other queries promoter: Contributions Query
========================================================= */
export async function getContributionsQueryPromoter(nifSearched?: string, dateFrom?:string, dateTo?:string): Promise<Array<Contribution>>{
    const params : {nifSearched?: string, dateFrom?:string, dateTo?:string, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string} = {nifSearched:nifSearched, dateFrom:dateFrom, dateTo:dateTo};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    let key = 'promoter_idPromoter_'+params.idPromoter+'_cdCompany_'+params.cdCompany+'_cdPlan_'+params.cdPlan+'_cdFund_'+params.cdFund+'_cdSubplan_'+params.cdSubplan+'_nifSearched_'+params.nifSearched+'_dateFrom_'+params.dateFrom+'_dateTo_'+params.dateTo+'_lang_'+params.lang;
    let cache = getContributionsQueryPromoterCache(key);
    if(cache){
        return cache;
    }
    const response = await callApiPost<Array<Contribution>>('/promoter/contributions_query', params, true);
    if(response){
        setContributionsQueryPromoterCache(response, key);
    }
    return response;
}


export async function exportContributionsQuery(title:string, nifSearched?: string, dateFrom?:string, dateTo?:string){
    const params : {nifSearched?: string, dateFrom?:string, dateTo?:string, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string, export:boolean} = {nifSearched:nifSearched, dateFrom:dateFrom, dateTo:dateTo, export:true};
    params.lang=getCurrentLang();
    const user = getUser();

    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }
    await callApiDownload(title, title, '/promoter/contributions_query', params, true);
}


/* Public document
========================================================= */
export async function getPublicDocuments(filename:string, name:string) {
    await callApiDownload(filename,  name,'/contents/get_public_documents', {filename:filename}, false);
}


/* Promoter document
========================================================= */
export async function getPromoterDocument(typeDocument:string) {
    let filename='';
    let name='';
    switch(typeDocument){
        case 'model-register-participants':
            filename = 'Modelo altas participes con email.xlsx';
            name = 'Modelo altas participes con email';
            break;
        case 'model-contributions':
            filename = 'Modelo_fichero_aportaciones.xlsx';
            name = 'Modelo fichero aportaciones';
            break;
        case 'model-worker-profile':
            filename = 'Modelo_datos_tipo_trabajador.xlsx';
            name = 'Modelo datos tipo trabajador';
            break;
        case 'help-register-participants':
            filename = 'DEFINICIÓN DEL FICHERO DE DATOS DE IDENTIFICACION FISCAL (ALTAS).pdf';
            name = 'Definición del fichero de datos de identificación fiscal (altas)';
            break;
        case 'help-contributions':
            filename = 'DEFINICIÓN DEL FICHERO DE APORTACIONES.pdf';
            name = 'Definición del fichero de aportaciones';
            break;
        case 'help-worker-profile':
            filename = 'DEFINICIÓN DEL FICHERO DE TIPO TRABAJADOR.pdf';
            name = 'Definición del fichero de tipo trabajador';
            break;
    }
    await callApiDownload(filename, name, '/promoter/get_document_promoter', {typeDocument:typeDocument}, true);
}

/* Send contributions
========================================================= */
export async function sendContributions(params : {year:number, month:number, file: string, fileName:string, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string}): Promise<{result: boolean, exists: boolean, errors?: string[]}>{

    params.lang=getCurrentLang();
    const user = getUser();


    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    const response = await callApiPost<{result: boolean, exists: boolean, errors?: string[]}>('/promoter/send_contributions', params, true);

    return response;
}


/* Send participants
========================================================= */
export async function sendParticipants(params : {file: string, fileName:string, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string}): Promise<{result: boolean, errors?: string[]}>{

    params.lang=getCurrentLang();
    const user = getUser();


    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    const response = await callApiPost<{result: boolean, errors?: string[]}>('/promoter/send_participants', params, true);

    return response;
}


/* Send worker profile
========================================================= */
export async function sendWorkerProfile(params : {file: string, fileName:string, idPromoter?: string, cdCompany?:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string}): Promise<{result: boolean, errors?: string[]}>{

    params.lang=getCurrentLang();
    const user = getUser();


    const planPromotor = getSelectedPlanPromotor();
    if(user && user.selectedPromotor && planPromotor){
        params.idPromoter = user.selectedPromotor;
        params.cdCompany = planPromotor?.compania;
        params.cdPlan = planPromotor?.codigo_plan;
        params.cdFund = planPromotor?.codigo_fondo;
        params.cdSubplan = planPromotor?.codigo_subplan;
    }

    const response = await callApiPost<{result: boolean, errors?: string[]}>('/promoter/send_worker_profile', params, true);

    return response;
}



/* Global position customer
========================================================= */
export async function getGlobalPosition(params: { show_plans: boolean, show_funds: boolean, show_others: boolean, calculate_risk_exposition: boolean } = { show_plans: true, show_funds: true, show_others: true, calculate_risk_exposition: false }): Promise<GlobalPosition> {
    let key = 'user_show_plans_'+params.show_plans+'_show_funds_'+params.show_funds+'_show_others_'+params.show_others+'_calculate_risk_exposition_'+params.calculate_risk_exposition;
    let response = getGlobalPositionCache(key);
    if(!response){
        response = await callApiPost<GlobalPosition>('/position/global_position', params, true);
        if(response){
            setGlobalPositionCache(response, key);

            if(response.planes){
                setPlansCache(response.planes);
            }

            if(response.fondos){
                setInvestmentFundsCache(response.fondos);
            }

            if(response.otros){
                setOtherProductsCache(response.otros);
            }
        }
    }

    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            if(response.planes && response.planes.length>0){
                response.planes.forEach(item=>{
                    if(item.product){
                        if(!item.product.informacionGeneral){
                            item.product.informacionGeneral = {}
                        }
                        item.product = translateProduct(item.product, translates);
                    }
                    item.tipoFondo = item.product?.informacionGeneral?.tipoFondo ?? item.tipoFondo;
                    return item;
                });
            }
            if(response.fondos && response.fondos.length>0){
                response.fondos.forEach(item=>{
                    if(item.product){
                        if(!item.product.informacionGeneral){
                            item.product.informacionGeneral={}
                        }
                        item.product = translateProduct(item.product, translates);
                        item.tipoFondo = item.product?.informacionGeneral?.tipoFondo ?? item.tipoFondo;
                    }
                    return item;
                });
            }
        }
    }

    return response;
}

/* Plans
========================================================= */
export async function getPlans(typePlan?:string): Promise<UserProduct[]> {
    let response:UserProduct[] =[];

    let cache = getPlansCache();
    if(cache){
        response=cache;
    }else{
        response = await callApiPost<UserProduct[]>('/position/plans', {}, true);
    }
    if(!cache && response){
        setPlansCache(response);
    }

    if(typePlan && response){
        response = response.filter(item=>(item.product?.individual??'')===typePlan);
    }

    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            response.forEach(item=>{
                if(item.product){
                    if(!item.product.informacionGeneral){
                        item.product.informacionGeneral = {}
                    }
                    item.product = translateProduct(item.product, translates);
                }
                item.tipoFondo = item.product?.informacionGeneral?.tipoFondo ?? item.tipoFondo;
                return item;
            });
        }
    }

    return response;
}

/* Plans Not Contracted
========================================================= */
export async function getPlansNotContracted(typePlan?:string): Promise<Product[]> {
    let response:Product[] =[];
    let cache = getPlansNotContractedCache();
    if(cache){
        response=cache;
    }else{
        response = await callApiPost<Product[]>('/products/plans/get_not_contracted_plans', {lang:getCurrentLang()}, true);
    }
    if(!cache && response){
        setPlansNotContractedCache(response);
    }
    if(response){
        response = response.filter(item=>(item.individual??'')===typePlan);
    }

    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            response.forEach(item=>{
                item = translateProduct(item, translates);
                return item;
            });
        }
    }

    return response
}


/* Investment funds
========================================================= */
export async function getInvestmentFunds(): Promise<UserProduct[]> {
    let response:UserProduct[] =[];
    let cache = getInvestmentFundsCache();
    if(cache){
        response=cache;
    }else{
        response = await callApiPost<UserProduct[]>('/position/funds', {}, true);
    }
    if(!cache && response){
        setInvestmentFundsCache(response);
    }

    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            response.forEach(item=>{
                if(item.product){
                    if(!item.product.informacionGeneral){
                        item.product.informacionGeneral = {}
                    }
                    item.product = translateProduct(item.product, translates);
                }
                item.tipoFondo = item.product?.informacionGeneral?.tipoFondo ?? item.tipoFondo;
                return item;
            });
        }
    }

    return response;
}


/* Get info contract
========================================================= */
export async function getInfoContract(params: {numContract:string, cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, lang?:string}): Promise<Contract>{
    params.lang=getCurrentLang();
    let response:Contract;
    let cache = getInfoContractCache(params.numContract, params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.lang);

    if(cache){
        response=cache;
    }else{
        switch(params.cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<Contract>('/products/plans/get_contract_plan', params, true);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<Contract>('/products/funds/get_contract_fund', params, true);
                break;
            case 5:
                response = await callApiPost<Contract>('/products/other_products/get_contract_other_products', params, true);
                break;
            default:
                response=undefined as unknown as Contract;
        }
    }

    if(!cache && response){
        setInfoContractCache(response, params.numContract, params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.lang);
    }

    return response;
}

/* Validate operate
========================================================= */
export async function validateOperate(params: {operation:number, numContract?: string, cdCompany?: number, cdPlan?: string, cdFund?: string, cdSubplan?: string, lang?: string}): Promise<{result: boolean, contract?: Contract, user?:Client, error?: string, extra?:any, signState?: SignState}>{
    params.lang=getCurrentLang();

    const userProduct = getCurrentUserProduct();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    const response = await callApiPost<{result: boolean, contract?: Contract, user?:Client, error?: string, extra?:any, signState?: SignState}>('/clients/validate_operate', params, true)


    if(response){
        if(response.result && response.contract){
            setCurrentUserContract(response.contract);
        }

        if(response.result && response.user){
            setCurrentUserData(response.user);
        }
        if(response.result && response.contract?.plan){
            setCurrentProductToContract(response.contract?.plan);
        }
    }

    return response;
}


/* Validate certificate
========================================================= */
export async function validateCertificate(params: {certificateSign:string, logSource?:string, lang?:string}): Promise<{result: boolean, error?: string}>{
    params.lang=getCurrentLang();
    params.logSource = getPlatform();

    return await callApiPost<{result: boolean, error?: string}>('/clients/validate_certificate', params, true)
}


/* Validate Contract data
========================================================= */
export async function isValidContractData(params: OperationContract): Promise<{result: boolean, errors?: []}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: []}>('/clients/is_valid_contract_data', params, true);
}


/* Validate Contract holders
========================================================= */
export async function isValidContracHolders(params: OperationContractHolders): Promise<{result: boolean, errors?: []}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: []}>('/products/fund/is_valid_contract_holders', params, true);
}


/* Investment fund: add contract fund
========================================================= */
export async function addContractFund(params: OperationContractFund): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/fund/add_fund_contract', params, true);
}


/* Pension plan: add contract plan
========================================================= */
export async function addContractPlan(params: OperationContractPlan): Promise<{result: boolean, urlSignature: string, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, urlSignature: string, errors?: [], tokenOperation?:string}>('/products/plan/add_plan_contract', params, true);
}

/* Pension plan: add contribution
========================================================= */
export async function addContribution(params: OperationContribution): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/plan/add_contribution', params, true);
}

/* Pension plan: add mobilization
========================================================= */
export async function addMobilization(params: OperationMobilization): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/plan/add_transfer', params, true);
}




/* Investment fund: add subscription
========================================================= */
export async function addSubscription(params: OperationSubscription): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/fund/add_subscription', params, true);
}
/* Investment fund: add transfer
========================================================= */
export async function addTransfer(params: OperationTransfer, contractHolders? : OperationContractHolders): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }
    
    if(contractHolders){
        params.contractHolders = contractHolders;
    }

    if(contractHolders){
        params.contractHolders = contractHolders;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/fund/add_transfer_fund', params, true);
}

/* Investment fund: add refund
========================================================= */
export async function addRefund(params: OperationRefund): Promise<{result: boolean, errors?: [], tokenOperation?:string}>{
    const userProduct = getCurrentUserProduct();
    params.logSource = getPlatform();
    params.lang = getCurrentLang();

    if(userProduct){
        params.numContract = userProduct?.numContrato;
        params.cdCompany = userProduct?.product?.cdCompania;
        params.cdPlan = userProduct?.product?.cdPlan;
        params.cdFund = userProduct?.product?.cdFondo;
        params.cdSubplan = userProduct?.product?.cdSubplan;
    }

    return await callApiPost<{result: boolean, errors?: [], tokenOperation?:string}>('/products/fund/add_refund', params, true);
}


/* RightsBalance
========================================================= */
export async function getRightBalance(params: {numContract:string, cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, date: string, lang?:string}): Promise<Rights>{
    params.lang=getCurrentLang();
    let response:Rights;

    switch(params.cdCompany){
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
            response = await callApiPost<Rights>('/products/plans/get_rights', params, true);
            break;
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
            response = await callApiPost<Rights>('/products/funds/get_balance', params, true);
            break;
        case 5:
            response = await callApiPost<Rights>('/products/other_products/get_balance_other_products', params, true);
            break;
        default:
            response = undefined as unknown as Rights;
            break;
    }
    return response;
}

/* Movements
========================================================= */
export async function getMovements(params: {numContract:string, cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string, lang?:string}): Promise<Array<Movement>>{
    params.lang=getCurrentLang();
    let response:Array<Movement>=[];

    switch(params.cdCompany){
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
            response = await callApiPost<Array<Movement>>('/products/plans/get_movements_plans', params, true);
            break;
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
            response = await callApiPost<Array<Movement>>('/products/funds/get_movements_funds', params, true);
            break;
        case 5:
            response = await callApiPost<Array<Movement>>('/products/other_products/get_movements_other_products', params, true);
            break;
        default:
            response = undefined as unknown as Array<Movement>;
            break;
    }
    return response;
}

export async function exportMovements(params: {numContract:string, cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string, title:string, action?:string, lang?: string}){
    params.lang=getCurrentLang();
    switch(params.cdCompany){
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
            await callApiDownload(params.title, params.title, '/products/plans/get_movements_plans', params, true);
            break;
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
            await callApiDownload(params.title, params.title, '/products/funds/get_movements_funds', params, true);
            break;
        case 5:
            await callApiDownload(params.title, params.title, '/products/other_products/get_movements_other_products', params, true);
            break;
    }
}

/* Contributions
========================================================= */
export async function getContributionCapital(params: {numContract:string, cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string, lang?:string}): Promise<Array<Contribution>>{
    params.lang=getCurrentLang();
    let response:Array<Contribution>=[];

    switch(params.cdCompany){
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
            response = await callApiPost<Array<Contribution>>('/products/plans/get_contributed_capital', params, true);
            break;
        default:
            response=undefined as unknown as Array<Contribution>;
    }
    return response;
}


/* Get products
========================================================= */
export async function getProducts(cdCompany:number): Promise<Product[]>{
    let response:Product[];
    let cache = getProductsCache(cdCompany);

    if(cache){
        response=cache;
    }else{
        switch(cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<Product[]>('/products/plans/get_plans', {}, false);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<Product[]>('/products/funds/get_funds', {}, false);
                break;
            default:
                response=undefined as unknown as Product[];
        }
    }

    if(!cache && response){
        setProductsCache(response, cdCompany);
    }



    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            response.forEach(item=>{
                item = translateProduct(item, translates);
                return item;
            });
        }
    }

    return response;
}

/* Product
========================================================= */
export async function getProduct(params: {cdCompany:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string, slug?:string}): Promise<Product|undefined>{
    params.lang=getCurrentLang();
    let products = getProductsCache(params.cdCompany);

    let product= undefined;
    if(products && products.length>0){
        product = products.find(item=>(params.cdCompany===item.cdCompania && params.slug && item.slug===params.slug) || (params.cdCompany===item.cdCompania && params.cdPlan===item.cdPlan && params.cdFund===item.cdFondo && params.cdSubplan===item.cdSubplan));
    }

    const messages = getTextsCache();

    if(messages && product){
        const translates = params.lang==='en' ? messages.en : messages.es;
        product = translateProduct(product, translates);

        if(product.fondos && product.fondos.length>0){
            product.fondos.forEach(item=>{
                item = translateProduct(item, translates);
                return item;
            });
        }
    }


    return product;
}



/* Plans
========================================================= */
export async function getPublicPlans(typePlan?:string): Promise<Product[]> {
    let response = await getProducts(parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'));

    if(typePlan && response){
        response = response.filter(item=>(item.individual??'')===typePlan);
    }

    return response;
}


/* Employment plan
========================================================= */
export async function getEmploymentPlan(): Promise<Product|null> {
    let plans = await getPublicPlans(process.env.REACT_APP_PLAN_PENSIONES_SIMPLIFICADOS ?? 'S');

    let plan= null;
    if(plans && plans.length>0){
        plan=plans[0];
        plan = await getInfoProduct({cdCompany: plan.cdCompania??1, cdPlan: plan.cdPlan, cdFund: plan.cdFondo, cdSubplan: plan.cdSubplan})
    }

    const messages = getTextsCache();

    if(messages && plan){
        const lang = getCurrentLang();
        const translates = lang==='en' ? messages.en : messages.es;
        plan = translateProduct(plan, translates);
    }

    return plan;
}


/* Info product
========================================================= */
export async function getInfoProduct(params: {cdCompany:number, cdPlan?:string, cdFund?:string, cdSubplan?:string, lang?:string, slug?:string}): Promise<Product>{
    const lang = getCurrentLang();
    params.lang=lang;
    let response:Product;
    let cache = getInfoProductCache(params.cdCompany, params.cdPlan??'', params.cdFund??'', params.cdSubplan??'', '', params.slug??'');

    if(cache){
        response=cache;
    }else{
        switch(params.cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<Product>('/products/plans/get_plan', params, false);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<Product>('/products/funds/get_fund', params, false);
                break;
            default:
                response=undefined as unknown as Product;
        }
    }

    if(!cache && response){
        setInfoProductCache(response, params.cdCompany, params.cdPlan??'', params.cdFund??'', params.cdSubplan??'', params.lang??'', params.slug??'');
    }

    const messages = getTextsCache();

    if(messages && response){
        const translates = lang==='en' ? messages.en : messages.es;
        response = translateProduct(response, translates);

        if(response.fondos && response.fondos.length>0){
            response.fondos.forEach(item=>{
                item = translateProduct(item, translates);
                return item;
            });
        }
    }

    return response;
}


/* Profitability Percentage
========================================================= */
export async function getProfitabilityPercentage(params: {cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string}) : Promise<{ result: number }>{
    let response:{ result: number };
    let cache = getProfitabilityPercentageCache(params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.dateFrom, params.dateTo);

    if(cache){
        response=cache;
    }else{
        switch(params.cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<{ result: number }>('/products/plans/get_profitability_percentage_plan', params, false);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<{ result: number }>('/products/funds/get_profitability_percentage_fund', params, false);
                break;
            default:
                response=undefined as unknown as { result: number };
        }
    }

    if(!cache && response){
        setProfitabilityPercentageCache(response, params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.dateFrom, params.dateTo);
    }

    return response;
}

/* Net asset value
========================================================= */
export async function getNetAssetValue(params: {cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string}) : Promise<Array<NetAssetValue>>{
    let response:Array<NetAssetValue>;
    let cache = getNetAssetValueCache(params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.dateFrom, params.dateTo);

    if(cache){
        response=cache;
    }else{
        switch(params.cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<Array<NetAssetValue>>('/products/plans/get_net_asset_value_plan', params, false);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<Array<NetAssetValue>>('/products/funds/get_net_asset_value_fund', params, false);
                break;
            default:
                response=undefined as unknown as Array<NetAssetValue>;
        }
    }

    if(!cache && response){
        setNetAssetValueCache(response, params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.dateFrom, params.dateTo);
    }

    return response;
}


export async function exportNetAssetValue(params: {cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, dateFrom: string, dateTo: string, title:string, lang?: string, action?:string}){
    params.lang=getCurrentLang();
    params.action='export';

    switch(params.cdCompany){
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
            await callApiDownload(params.title, params.title, '/products/plans/get_net_asset_value_plan', params, false);
            break;
        case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
            await callApiDownload(params.title, params.title, '/products/funds/get_net_asset_value_fund', params, false);
            break;
    }
}

/* Contract data save
========================================================= */
export async function setContractData(params: any): Promise<{ result: boolean, errors?: [], tokenOperation?:string }> {
    const response = await callApiPost<{ result: boolean, errors?: [], tokenOperation?:string }>('/clients/save_changes_address_postal', params, true);
    return response;
}

/* Wallet Composition
========================================================= */
export async function getWalletCompositionProduct(params: {cdCompany:number, cdPlan:string, cdFund:string, cdSubplan:string, date: string, lang?:string}) : Promise<Array<PortfolioComposition>>{
    params.lang=getCurrentLang();
    let response:Array<PortfolioComposition>;
    let cache = getWalletCompositionProductCache(params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.date, params.lang);

    if(cache){
        response=cache;
    }else{
        switch(params.cdCompany){
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_PENSIONES ?? '1'):
                response = await callApiPost<Array<PortfolioComposition>>('/products/plans/get_wallet_composition_plan', params, false);
                break;
            case parseInt(process.env.REACT_APP_COMPANIA_FONDITEL_FONDOS ?? '3'):
                response = await callApiPost<Array<PortfolioComposition>>('/products/funds/get_wallet_composition_fund', params, false);
                break;
            default:
                response=undefined as unknown as Array<PortfolioComposition>;
        }
    }

    if(!cache && response){
        setWalletCompositionProductCache(response, params.cdCompany, params.cdPlan, params.cdFund, params.cdSubplan, params.date, params.lang);
    }

    return response;
}

/* Banners
========================================================= */

export async function updateStadisticsBanner(params: {cdBanner:number, view:boolean, click:boolean, close:boolean}): Promise<{ result: boolean, errors?: [], tokenOperation?:string }> {
    const response = await callApiPost<{ result: boolean, errors?: [], tokenOperation?:string }>('/clients/update_stadistics_banner', params, true);
    return response;
}

/* Investment Funds Not Contracted
========================================================= */
export async function getInvestmentFundsNotContracted(): Promise<Product[]> {
    let response:Product[] =[];
    let cache = getInvestmentFundsNotContractedCache();

    if(cache){
        response=cache;
    }else{
        response = await callApiPost<Product[]>('/products/funds/get_not_contracted_funds', {lang:getCurrentLang()}, true);
    }

    if(!cache && response){
        setInvestmentFundsNotContractedCache(response);
    }



    if(response){
        const lang = getCurrentLang();
        const messages = getTextsCache();

        if(messages){
            const translates = lang==='en' ? messages.en : messages.es;
            response.forEach(item=>{
                item = translateProduct(item, translates);
                return item;
            });
        }
    }

    return response;
}

/* Other products
========================================================= */
export async function getOtherProducts(): Promise<UserProduct[]> {
    let response:UserProduct[] =[];
    let cache = getOtherProductsCache();
    if(cache){
        response=cache;
    }else{
        response = await callApiPost<UserProduct[]>('/position/other_products', {}, true);
    }
    if(!cache && response){
        setOtherProductsCache(response);
    }

    return response;
}


export async function getAdvises(): Promise<Notices[]> {
    const response = await callApiPost<Notices[]>('/clients/get_advises', {}, true);

    return response;
}

export async function getNumberAdvises(): Promise<{ result: number }> {
    let cache = getNumberAdvisesCache();
    if(cache){
        return cache;
    }

    const response = await callApiPost<{ result: number }>('/clients/get_number_advises', {}, true);
    if(response){
        setNumberAdvisesCache(response);
    }
    return response;
}

export async function setReleaseState(cdInfo: number, state:string='Leido'): Promise<{ result: boolean }> {
    const response = await callApiPost<{ result: boolean }>('/clients/set_release_state', {cdInfo: cdInfo, state: state}, true);
    return response;
}

export async function getNumberCourseOperations(): Promise<{ result: number }> {
    let cache = getNumberCourseOperationsCache();
    if(cache){
        return cache;
    }

    const response = await callApiPost<{ result: number }>('/operations/get_number_course_operations', {}, true);
    if(response){
        setNumberCourseOperationsCache(response);
    }
    return response;
}

export async function getCourseOperations(): Promise<OperationInProgress[]> {
    const response = await callApiPost<OperationInProgress[]>('/operations/get_course_operations', {}, true);
    let operacionesEnCurso : OperationInProgress[] = [];
    if(response){
        const arr = Object.values(response) as [];
        arr.forEach(operacion  =>{
            const operacionEnCurso = operacion as OperationInProgress;

            if(operacionEnCurso.detalle.intervinientes){
                const intervinientes = Object.values(operacionEnCurso.detalle.intervinientes) as ContractHolder[];
                operacionEnCurso.detalle.intervinientes = intervinientes;
            }else{
                operacionEnCurso.detalle.intervinientes = [];
            }

            if(operacion)
                operacionesEnCurso.push(operacion);
        })
    }
    return operacionesEnCurso;
}

export async function cancelOperations(params:{numSolicitud: string, operationsKey?: string, electronic?: boolean, dateSign?: number, tokenSign?: string, tokenOperation?: string, logSource?:string}): Promise<{ result: string, tokenOperation?:string }> {
    params.logSource= getPlatform();
    const response = await callApiPost<{ result: string, tokenOperation?:string }>('/operations/cancel_operation', params, true);
    return response;
}

export async function signOperations(params:any): Promise<{ result: boolean, tokenOperation?:string }> {
    params.logSource = getPlatform();
    const response = await callApiPost<{ result: boolean, tokenOperation?:string }>('/operations/sign_operation', params, true);
    return response;
}

export async function rejectOperations(params:any): Promise<{ result: boolean, tokenOperation?:string }> {
    params.logSource = getPlatform();
    const response = await callApiPost<{ result: boolean, tokenOperation?:string }>('/operations/reject_operation', params, true);
    return response;
}

export async function getPlanFiscalInformation(): Promise<TaxInformation[]> {
    let cache = getPlanFiscalInformationCache();
    if(cache){
        return cache;
    }
    const response = await callApiPost<TaxInformation>('/products/plans/plans_fiscal_information', {}, true);
    let informacion_fiscal :TaxInformation[] = [];
    if(response && response.informacion_fiscal){
        const arr = Object.values(response.informacion_fiscal) as [];

        arr.forEach(info  =>{
            const infoFiscal = info as TaxInformationPlanYear[];
            if(info)
                informacion_fiscal.push({year: infoFiscal[0].anioFiscal, informacion_fiscal: infoFiscal})
        })
    }

    let data = informacion_fiscal.reverse();
    setPlanFiscalInformationCache(data);
    return data;
}

export async function getFundFiscalInformation(): Promise<TaxInformationFunds[]> {

    let cache = getFundFiscalInformationCache();
    if(cache){
        return cache;
    }

    const response = await callApiPost<any>('/products/funds/funds_fiscal_information', {}, true);
    let informacion_fiscal :TaxInformationFunds[] = [];
    if(response && response.informacion_fiscal){

        for(const [key, info] of Object.entries(response.informacion_fiscal)){
            const infoFiscal = info as TaxInformationFundYear[];

            infoFiscal.forEach(infoFiscalFI =>{
                if(infoFiscalFI.titulares){
                    const titulares = (infoFiscalFI.titulares as any) as ContractHolder[];
                    infoFiscalFI.titulares = titulares;
                }else{
                    infoFiscalFI.titulares = [];
                }

                if(infoFiscalFI.gananciasPerdidas){
                    const gananciasPerdidas = (infoFiscalFI.gananciasPerdidas as any) as LostProfit[];
                    infoFiscalFI.gananciasPerdidas = gananciasPerdidas;
                }else{
                    infoFiscalFI.gananciasPerdidas = [];
                }
            });

            if(info){
                if(infoFiscal.length > 0)
                    informacion_fiscal.push({year: parseInt(key), informacion_fiscal: infoFiscal})
            }
        }
    }

    let data = informacion_fiscal.reverse();
    setFundFiscalInformationCache(data);
    return data;
}

export async function getDocumentsOnlineCorrespondence(params: DocumentSearch): Promise<DocumentCO[]> {
    params.cdLang=getCurrentLang();
    const response = await callApiPost<DocumentCO[]>('/clients/get_documents_co', params, true);
    return response;
}

export async function getDocumentsTypeOnlineCorrespondence(cdCompany: number): Promise<DocumentTypeCO[]> {
    const lang = getCurrentLang();
    let cache = getDocumentsTypeOnlineCorrespondenceCache(lang, cdCompany);
    if(cache){
        return cache;
    }

    const response = await callApiPost<DocumentTypeCO[]>('/clients/get_documents_type_co', {lang: lang, cdCompany: cdCompany}, true);

    if(response){
        setDocumentsTypeOnlineCorrespondenceCache(lang, cdCompany, response);
    }

    return response;
}

export async function getDocumentsTypeCompaniesOnlineCorrespondence(): Promise<Company[]> {
    const lang = getCurrentLang();
    let cache = getDocumentsTypeCompaniesOnlineCorrespondenceCache(lang);
    if(cache){
        return cache;
    }

    const response = await callApiPost<Company[]>('/clients/get_documents_type_companies_co', {lang: getCurrentLang()}, true);

    if(response){
        response.forEach(item=>{
            if(item.tiposDocumentos && item.tiposDocumentos.length>0){
                setDocumentsTypeOnlineCorrespondenceCache(lang, item.cdCompania, item.tiposDocumentos);
            }
        })

        setDocumentsTypeCompaniesOnlineCorrespondenceCache(lang, response);
    }
    return response;
}

export async function setOnlineCorrespondenceType(params:any): Promise<{ result: boolean }> {
    const response = await callApiPost<{ result: boolean }>('/clients/set_correspondence_type', params, true);
    return response;
}

export async function downloadFile(fileName:string, url: string, params: any = null, tokenRequired: boolean=false){
    try{
        if(isNativeApp){
            FirebasePerformance.startTrace({ traceName: url }).then(()=>{});
        }
    }catch(err){}

    await axios({
        method: 'GET',
        url: url,
        data: params ? params : null,
        responseType: 'blob',
        headers: tokenRequired  ? { Authorization: `Bearer ${ getTokenApi()}` } : {Accept: `application/json`, "Content-Type": `application/json` }
    })
    .then(async(response) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: url }).then(()=>{});
            }
        }catch(err){}
        if(isNativeApp){
            fileToBase64(response.data).then(data => {
                Filesystem.writeFile({
                    path: fileName,
                    data: data,
                    directory: Directory.Data
                }).then(async(result:any)=>{
                    // Se debe especificar que tipo de archivo es
                    const extension = (fileName.split('.')[1]);
                    let mimeType = "application/"+extension;
                    if(extension==='xlsx'){
                        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                    // Abrir archivo
                    await FileOpener.open({filePath:result.uri, openWithDefault:true, contentType:mimeType, chooserPosition:{x:0, y:0}})
                })
            });
        }else{
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(response.data);
            a.download = `${fileName}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    }).catch(async (error: AxiosError) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: url }).then(()=>{});
            }
        }catch(err){}
        trackError('Error call api: '+(url)+ ' - '+(error?.message ?? ''));
    })
}

async function callApiDownload(fileName:string, trackName:string, endpoint: string, params: any = null, tokenRequired: boolean=true){
    try{
        if(isNativeApp){
            FirebasePerformance.startTrace({ traceName: process.env.REACT_APP_API_URL+endpoint }).then(()=>{});
        }
    }catch(err){}

    if(tokenRequired && !isValidToken()){
        removeUser();
        return;
    }
    await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL+endpoint,
        data: params ? params : null,
        responseType: 'blob',
        headers: tokenRequired  ? { Authorization: `Bearer ${ getTokenApi()}` } : {Accept: `application/json`, "Content-Type": `application/json` }
    })
    .then(async(response) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: process.env.REACT_APP_API_URL+endpoint }).then(()=>{});
            }
        }catch(err){}
        if(isNativeApp){
            fileToBase64(response.data).then(data => {
                Filesystem.writeFile({
                    path: fileName,
                    data: data,
                    directory: Directory.Data
                }).then(async(result:any)=>{
                    // Se debe especificar que tipo de archivo es
                    const extension = (fileName.split('.')[1]);
                    let mimeType = "application/"+extension;
                    if(extension==='xlsx'){
                        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                    // Abrir archivo
                    await FileOpener.open({filePath:result.uri, openWithDefault:true, contentType:mimeType, chooserPosition:{x:0, y:0}})
                })
            });
        }else{
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(response.data);
            a.download = `${fileName}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
        trackStadistics('DOWNLOAD_REPORT', '', fileName, trackName);
    }).catch(async (error: AxiosError) => {
        try{
            if(isNativeApp){
                FirebasePerformance.stopTrace({ traceName: process.env.REACT_APP_API_URL+endpoint }).then(()=>{});
            }
        }catch(err){}
        trackError('Error call api: '+(process.env.REACT_APP_API_URL+endpoint)+ ' - '+(error?.message ?? ''));
    })
}

export async function getDocument(titulo: string, documentId: number) {
    await callApiDownload(titulo, titulo, '/contents/download_document', {documentId: documentId}, false);
    //await callApiDownload(titulo, titulo, '/documents/get_document_bia', {cdDocument: documentId}, false);
}

export async function getDocumentWithAuthorization(titulo: string, documentId: number) {
    //await callApiDownload(titulo, titulo, '/contents/download_document', {documentId: documentId}, false);
    await callApiDownload(titulo, titulo, '/documents/authorization_get_document_bia', {cdDocument: documentId}, true);
}

export async function getDocumentPublic(documentId: string) {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const urlCompleta = `${apiUrl}/documents/get_document/${documentId}`; 

        const response = await fetch(urlCompleta, {
            method: 'GET',
            headers: {
                'Accept': 'application/pdf', 
            },
        });

        if (!response.ok) {
            throw new Error('Error al obtener el documento');
        }

        const blob = await response.blob(); 
        const url = window.URL.createObjectURL(blob); 
        
        return url; 
    } catch (error) {
        console.error('Error al descargar el documento:', error);
        throw error; 
    }
}

export async function getDocumentsSustainabilityWeb() {
    const response = await callApiPost<DocumentSustainability[]>('/documents/get_documents_sustainability_web', {}, false);

    return response;
}

export async function getGeneralDocumentInformation(titulo: string, params: { cdCompany:number, cdPlan:string, cdFund:string, numContract?:string, idPromoter?:string, lang?:string}) {
    params.lang=getCurrentLang();
    await callApiDownload(titulo, titulo, '/documents/general_document_information', params, true);
}


export async function getCartaTraspaso(titulo: string, contract: string, date: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/transfer_letter', {contract: contract, date: date, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getCertificadoAportacionesPP(titulo: string, cdFund: string, cdPlan: string, cdSubplan: string, fiscalExercise: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/pp_aportations_certificated', {cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, fiscalExercise: fiscalExercise, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getCertificadoAportacionesPPConyuges(titulo: string, cdFund: string, cdPlan: string, cdSubplan: string, fiscalExercise: string, nifSpouse: string, contractNumber: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/pp_spouse_aportations_certificated', {cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, fiscalExercise: fiscalExercise, nifSpouse: nifSpouse, contractNumber: contractNumber, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getCertificadoAportacionesPPMinusvalidos(titulo: string, cdFund: string, cdPlan: string, cdSubplan: string, fiscalExercise: string, nifHandicapped: string, contractNumber: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/pp_handicapped_aportations_certificated', {cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, fiscalExercise: fiscalExercise, nifHandicapped: nifHandicapped, contractNumber: contractNumber, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getCertificadoRetencionesPP(titulo: string, cdFund: string, cdPlan: string, cdSubplan: string, fiscalExercise: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/pp_withholdings_certificated', {cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, fiscalExercise: fiscalExercise, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getFiniquitoPP(titulo: string, dateData: string, cdFund: string, cdPlan: string, cdSubplan: string, fiscalExercise: number, typeOfFacility: string, capitalRentaMixed: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/liquidation_settlement', {dateData: dateData, cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, fiscalExercise: fiscalExercise, typeOfFacility: typeOfFacility, capitalRentaMixed: capitalRentaMixed, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getReconocimientoDerechos(titulo: string, cdFund: string, cdPlan: string, cdSubplan: string, contract: string, contingency: string, date: string, numeral: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/recognition_rights', {cdFund: cdFund, cdPlan: cdPlan, cdSubplan: cdSubplan, contract: contract, contingency: contingency, date: date, numeral: numeral, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getInformacionFiscalFI(titulo: string, identificador: string, ordenDomicilio: string, anio: string, fechaEmision: string, cuenta: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/tax_information_fi', {identifier: identificador, orderAddress: ordenDomicilio, year: anio, broadcastDate: fechaEmision, account: cuenta, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getExtractoFI(titulo: string, codigoUnico: string, ordenDomicilio: string, fechaDesde: string, fechaHasta: string, cuenta: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/extract_fi', {uniqueCode: codigoUnico, orderAddress: ordenDomicilio, dateFrom: fechaDesde, dateTo: fechaHasta, account: cuenta, lang: getCurrentLang(), logSource: ''}, true);
}

export async function getExtractoPP(titulo: string, rangoFechaDesde: string, rangoFechaHasta: string, grupo: string) {
    await callApiDownload(titulo + '.pdf', titulo, '/documents/extract_pp', {rangeDateFrom: rangoFechaDesde, rangeDateTo: rangoFechaHasta, printGroup: grupo, lang: getCurrentLang(), logSource: ''}, true);
}

export async function recordTracking(params: { event:string, title:string, location:string, mobile:boolean, os:string, osVersion:string, browser:string, browserVersion:string, browserMajorVersion:number, screen:string, key:string }): Promise<{ result: boolean }> {
    const response = await callApiPost<{ result: boolean }>('/clients/record_tracking', params, true);
    return response;
}

export async function trackStadistics(eventType:string, eventKey?:string, locationDoc?:string, otherTitle?:string, newKey?:string){

    var unknown = '-';

    // screen
    var screenSize = '';
    if (window.screen.width) {
        var width = (window.screen.width) ? window.screen.width : '';
        var height = (window.screen.height) ? window.screen.height : '';
        screenSize += '' + width + " x " + height;
    }

    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // Opera
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Edge
    else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 5);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

    majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    // mobile version
    var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // cookie
    var cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
    }

    // system
    var os = unknown;
    var clientStrings = [
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista', r:/Windows NT 6.0/},
        {s:'Windows Server 2003', r:/Windows NT 5.2/},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98', r:/(Windows 98|Win98)/},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE', r:/Windows CE/},
        {s:'Windows 3.11', r:/Win16/},
        {s:'Android', r:/Android/},
        {s:'Open BSD', r:/OpenBSD/},
        {s:'Sun OS', r:/SunOS/},
        {s:'Linux', r:/(Linux|X11)/},
        {s:'iOS', r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X', r:/Mac OS X/},
        {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX', r:/QNX/},
        {s:'UNIX', r:/UNIX/},
        {s:'BeOS', r:/BeOS/},
        {s:'OS/2', r:/OS\/2/},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = unknown;

    if (os!=null && /Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)?.[1] ?? '';
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS X':
            osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)?.[1] ?? '';
            break;

        case 'Android':
            osVersion = /Android ([\.\_\d]+)/.exec(nAgt)?.[1] ?? '';
            break;

        case 'iOS':
            const iOSVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            if(iOSVersion){
                osVersion = iOSVersion[1] + '.' + iOSVersion[2] + '.' + (iOSVersion?.[3]??'0');
            }
            break;
    }

    let jscd = {
        event: eventType,
        title: ((otherTitle !== undefined) ? otherTitle : document.title)+(isNativeApp ? ' -APP' : ''),
        location: (locationDoc !== undefined) ? locationDoc : window.location.pathname,
        mobile: mobile,
        os: os,
        osVersion: osVersion,
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        screen: screenSize,
        cookies: cookieEnabled,
        callCenter: (getUser() && getUser().callCenter) ? getUser().callCenter : null,
        key: (newKey !== undefined) ? newKey : ((eventKey !== undefined) ? getOptionNavigationInverse(window.location.pathname)?.props?.children?.key + eventKey ?? '' : getOptionNavigationInverse(window.location.pathname)?.props?.children?.key ?? '')
    };

    if(getUser()){
        recordTracking(jscd);
    }
}